
import './EscalationGroupView.scss';
import { EscalationsGroupInterface, InheritanceStatus } from "@swivl-mono/types";
import { InheritanceTag } from '../../../../Components/InheritanceTag/InheritanceTag';
import EscalationsModel from "../../../../Models/Escalations/Escalations.Model";
import React from 'react';
import { Spinner } from '@swivl-mono/ui';


interface Props {
    group: EscalationsGroupInterface;
}

export function ParentEscalationGroupView(props: Props) {
    const { group } = props;
    const [isCustomizing, setIsCustomizing] = React.useState(false);
    const customizeClicked = async () => {
        setIsCustomizing(true);
        await EscalationsModel.makeGroupAChild(group); 

    }
    return <div className="EscalationGroup">
            <header>
            <InheritanceTag inheritance={InheritanceStatus.IS_PARENT} />    

                <h3 >{group.name}</h3>   
                {isCustomizing ? <Spinner/>:<div className="removeButton" onClick={customizeClicked}>CUSTOMIZE</div>}
                </header>
            </div>
}